import React, { useState } from "react";
import "./DappEngage.css";

export default function DappEngage() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Custom dApp Design & Development",
      description:
        "End-to-end decentralized application development tailored to business logic, user experience, and blockchain requirements, from architecture design to deployment.",
    },
    {
      id: 2,
      title: "Smart Contract Development & Auditing",
      description:
        "Secure, gas-efficient smart contracts built with verified logic and audited code to ensure reliability, transparency, and protection against vulnerabilities.",
    },
    {
      id: 3,
      title: "DeFi Application Development",
      description:
        "Development of decentralized finance platforms, including staking, lending, liquidity pools, and yield mechanisms, with scalable and compliant architecture.",
    },
    {
      id: 4,
      title: "DAO Design & Governance Development",
      description:
        "Design and implementation of decentralized governance models with voting mechanisms, treasury management, and automated decision-making frameworks.",
    },
    {
      id: 5,
      title: "NFT Marketplace & Token Development",
      description:
        "Creation of NFT marketplaces and token ecosystems enabling minting, trading, ownership tracking, and monetization of digital assets.",
    },
    {
      id: 6,
      title: "Multi-Chain dApp & Cross-Chain Integration",
      description:
        "Development of dApps that operate across multiple blockchains, enabling interoperability, optimized performance, and reduced dependency on a single network.",
    },
  ];

  return (
    <div id="dapp-engage" className="dappmainclass">
     <div className="top">
        <div className="left">
             <h2 className="heading">
    Scalable dApp Solutions for Real-World Web3 Use </h2>
      <p className="subheading">
     Our decentralized app development services deliver secure architecture, smooth performance, and growth-ready platforms designed for long-term use.</p>
        </div>
        <div className="right">
            <button>Get in touch</button>
        </div>
     </div>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
